import { GridRows as VisxGridRows } from '@visx/grid';
import { AllGridRowsProps } from '@visx/grid/lib/grids/GridRows';

import { GridLines } from './GridLines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';
import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';

export type GridRowsProps = {
  highlightZeroLine?: boolean;
} & AllGridRowsProps<AnyScale>;

export const GridRows = ({
  scale,
  highlightZeroLine = true,
  ...restProps
}: GridRowsProps) => (
  <VisxGridRows scale={scale} {...restProps}>
    {({ lines }) => (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    )}
  </VisxGridRows>
);
